<div class="rs-panel-flex">
  <div class="rs-panel-flex-cell rs-bg-grey2 rs-flex rs-flex-dir-col">
      <h2 class="rs-tit5">{{ 'nortonFamily.details.title' | translate }}</h2>
      <p>{{ 'nortonFamily.details.description' | translate }}</p>
      <p *ngIf="key && !isPending">{{ 'nortonFamily.details.productKey.label' | translate }} <strong>{{key}}</strong></p>
      <div class="rs-flex-grow rs-flex rs-flex-bottom">
        <div class="rs-maxw">
          <a href="{{ downloadLink }}" [ngClass]="{
        'rs-btn-waiting': !key || isPending }" class="rs-btn rs-btn-second " target="_blank">
            {{ 'nortonFamily.details.download.label' | translate }}
            <i class="icon-Target-Blank rs-margin-left1"
              title="{{ 'nortonFamily.details.download.tooltip' | translate }}"> <span class="show-for-sr">{{
                'nortonFamily.details.download.tooltip' | translate }}</span></i>
                <div *ngIf="!key || isPending" class="rs-btn-waiting-dots"></div>
          </a>
          <div class="show-for-medium-up rs-margin-top2">&nbsp;</div>
        </div>
      </div>
  </div>
</div>